import { render } from "./CourseTest.vue?vue&type=template&id=759d44f3&scoped=true"
import script from "./CourseTest.vue?vue&type=script&lang=js"
export * from "./CourseTest.vue?vue&type=script&lang=js"

import "./CourseTest.vue?vue&type=style&index=0&id=759d44f3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759d44f3"]])

export default __exports__